import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DynamicTitle = () => {
  const location = useLocation();

  useEffect(() => {
    let base = "JAC Board | ";

    // 🔹 Class IX
    if (
      location.pathname === "/" ||
      location.pathname.startsWith("/class-ix") ||
      location.pathname.startsWith("/backdoor-login-cl-9") ||
      location.pathname.startsWith("/list-of-examinees-cl-9") ||
      location.pathname.startsWith("/generate-pdf-class-ix")
    ) {
      base = "Class - IX - School Login (JAC Board) | ";
    }
    // 🔹 Class XII
    else if (location.pathname.startsWith("/class-xii")) {
      base = "Class - XII - School Login (JAC Board) | ";
    }
    // 🔹 Class XI
    else if (
      location.pathname.startsWith("/class-xi") ||
      location.pathname.startsWith("/backdoor-login-cl-11") ||
      location.pathname.startsWith("/list-of-examinees-cl-11") ||
      location.pathname.startsWith("/generate-pdf-class-xi")
    ) {
      base = "Class - XI - School Login (JAC Board) | ";
    }

    // 🔹 Class X
    else if (location.pathname.startsWith("/class-x")) {
      base = "Class - X - School Login (JAC Board) | ";
    }
    // 🔹 DEO
    else if (
      location.pathname.startsWith("/deo") ||
      location.pathname.startsWith("/total-schools") ||
      location.pathname.startsWith("/initiate-verification") ||
      location.pathname.startsWith("/total-applicant")
    ) {
      base = "Class - IX - DEO Login (JAC Board) | ";
    }
    // 🔹 Specific Accounts Pages first
    else if (location.pathname.startsWith("/secondary-accounts")) {
      base = "FO Login - Secondary (JAC Board) | ";
    } else if (location.pathname.startsWith("/intermediate-accounts")) {
      base = "FO Login - Intermediate (JAC Board) | ";
    }
    // 🔹 Specific Admin Pages next
    else if (location.pathname.startsWith("/secondary-admin")) {
      base = "Admin Login - Secondary (JAC Board) | ";
    } else if (location.pathname.startsWith("/intermediate-admin")) {
      base = "Admin Login - Intermediate (JAC Board) | ";
    }
    // 🔹 Broader secondary page
    else if (location.pathname.startsWith("/secondary")) {
      base = "Secondary Home Page - (JAC Board) | ";
    } else if (location.pathname.startsWith("/intermediate")) {
      base = "intermediate Home Page - (JAC Board) | ";
    } else if (location.pathname.startsWith("/correction-portal-class-xii")) {
      base = "Class - XII - Correction Portal (JAC Board) | ";
    } else if (location.pathname.startsWith("/correction-portal-class-x")) {
      base = "Class - X - Correction Portal (JAC Board) | ";
    }
    let i = 0;
    const speed = 250;
    const id = setInterval(() => {
      document.title = base.slice(i) + base.slice(0, i);
      i = (i + 1) % base.length;
    }, speed);

    return () => clearInterval(id);
  }, [location.pathname]);

  return null;
};

export default DynamicTitle;
